import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueCookies from 'vue-cookies'
import 'element-ui/lib/theme-chalk/index.css'



Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueCookies)

Vue.prototype.$postMessage =function (event, msg) {
  if (window.parent) {
      window.parent.postMessage({ event, msg }, '*')
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


